import { Variant } from "react-bootstrap/esm/types";

interface IOwnProps {
  color: Variant;
  text: string;
  badge?: boolean;
}

const Badge: React.FC<IOwnProps> = (props) => {
  return (
    <span className={`${props.badge ? 'badge' : 'px-2 py-1 rounded'} text-bg-${props.color}`}>{props.text}</span>
  );
};

export default Badge;
